import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const getTitle = ({ type, code, currentStatus, documentStatus }) => {
  const obj = {
    invalidEmail: `notification:${type}:description:${currentStatus}:${code}`,
    sendToSign: `notification:${type}:description:${currentStatus}:${code}`,
    zipReady: `notification:${type}:description:zip:ready`,
    zipError: `notification:${type}:description:zip:error`,
    certificateGenerated: `notification:${type}:certificate:generated`,
    default: `notification:${type}:description:${currentStatus}:${documentStatus}`
  };
  return obj[code] || obj.default;
};

const DescriptionList = ({ notif, currentStatus, documentStatus, documentName, currentStepType }) => {
  const { t } = useTranslation();
  let titleStatus = getTitle({ type: notif.type, code: notif.code, currentStatus, documentStatus });
  let typeOfSignature = `notification:${notif.type}:description:${currentStepType}`;
  let title = t(titleStatus, { elementName: documentName, tipoFirma: t(typeOfSignature) });
  title = currentStepType === 'notificationStep' ? title.replace('la firma', '') : title;
  return (
    <Typography component='span' color='textSecondary' title={title}>
      {title}
    </Typography>);
};

DescriptionList.propTypes = {
  notif: PropTypes.object,
  currentStatus: PropTypes.string,
  documentStatus: PropTypes.string,
  documentName: PropTypes.string,
  currentStepType: PropTypes.string
};

export default DescriptionList;
